import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LogoFW from '../components/LogoFW';
import styles from '../style/style.scss';

function NotFoundPage() {
  const [count, setCount] = useState(10);
  const navigate = useNavigate();
  useEffect(() => {
    if (count === 0) {
      navigate('/');
    }
    setTimeout(() => {
      setCount(count - 1);
    }, 1000);
  }, [count]);

  return (
    <div className={styles.fwcontainer}>
      <LogoFW />
      <div className="mb-5" />
      <h1 className="display-1 text-center">Nie znaleziono strony</h1>
      <Link to="/">Powrót na strone główną za {count} sek</Link>
    </div>
  );
}

export default NotFoundPage;
